<div class="p-top-seatmap-flight js-seatmap-flight">
  <div class="l-wrap">
    <div class="l-wrap__inner" (click)="onSelectChange()">
      <div class="p-top-seatmap-flight__wrap">
        <button
          id="segmentsButton"
          [ngClass]="
            isOneOrNoneSegment()
              ? 'p-top-seatmap-flight__head js-top-float-accordion-btn cursor-reset'
              : 'p-top-seatmap-flight__head js-top-float-accordion-btn'
          "
        >
          <span class="p-top-seatmap-flight__head-wrap">
            <span class="p-top-seatmap-flight__head-label">
              <span class="p-top-seatmap-flight__airport">
                <span class="p-top-seatmap-flight__airport-departure">
                  {{ (getDepartureLocationCode() | airportNameI18n) || getDepartureLocationName() }}
                  <span class="p-top-seatmap-flight__airport-to">
                    <span
                      class="u-visually-hidden"
                      innerHTML="{{ 'm_static_message-alt.toOfArrivalAndDeparture' | staticMsg }}"
                    ></span>
                    <span aria-hidden="true">{{ 'label.hyphen' | staticMsg }}</span>
                  </span>
                </span>
                <span class="p-top-seatmap-flight__airport-arrival">
                  {{ (getArrivalLocationCode() | airportNameI18n) || getArrivalLocationName() }}
                </span>
              </span>
              <span class="p-top-seatmap-flight__status">
                <span class="p-top-seatmap-flight__status-airframe">
                  {{ getFlightName(displayTargetSegment) }}
                  <span
                    *ngIf="
                      !!displayTargetSegment?.operatingAirlineCode &&
                      displayTargetSegment?.operatingAirlineCode !== appConstants.CARRIER.TWO_LETTER
                    "
                    class="p-top-seatmap-flight__status-operation p-top-seatmap-flight__status-operation--gray60"
                  >
                    <span
                      [outerHTML]="
                        'label.segmanetOpCarrierWording'
                          | staticMsg
                            : {
                                '0':
                                  (displayTargetSegment?.operatingAirlineCode
                                  | carrierName : displayTargetSegment?.operatingAirlineName)
                              }
                      "
                    ></span>
                  </span>
                </span>
              </span>
            </span>
            <span class="p-top-seatmap-flight__head-unit">
              <span
                class="p-top-seatmap-flight-unit-one-segment"
                [ngClass]="
                  isOneOrNoneSegment() ? 'p-top-seatmap-flight-unit-one-segment' : 'p-top-seatmap-flight__unit'
                "
              >
                <span class="p-top-seatmap-flight__unit-num js-seatmap-flight-num">
                  <span
                    *ngIf="!!allSegmentInfo"
                    [innerHTML]="
                      'label.segmentListButton'
                        | staticMsg : { '0': displaySegmentIndex + 1, '1': allSegmentInfo.length }
                    "
                  >
                  </span>
                  <span
                    class="u-visually-hidden"
                    *ngIf="!!allSegmentInfo"
                    [innerHTML]="
                      'reader.segmentListButton'
                        | staticMsg : { '0': displaySegmentIndex + 1, '1': allSegmentInfo.length }
                    "
                  >
                  </span>
                </span>
              </span>
            </span>
          </span>
        </button>
      </div>

      <div id="segmentShowHide" class="p-top-seatmap-flight__body js-top-float-accordion-contents">
        <asw-seatmap-segments-change
          [allSegmentInfo]="allSegmentInfo"
          [displayTargetSegmentId]="displayTargetSegmentId"
          [pnrInfo]="pnrInfo"
          (clickSegment)="onClickSegment($event)"
        ></asw-seatmap-segments-change>
        <span
          class="u-visually-hidden"
          innerHTML="{{
            isDropDownDisplay ? ('reader.notDisplaySegmentList' | staticMsg) : ('reader.displaySegmentList' | staticMsg)
          }}"
        ></span>
      </div>
    </div>
  </div>
</div>
